export default __webpack_public_path__ + "static/media/Background 5_00058.56d221bb.png";